module.exports = __webpack_public_path__ + "img/rule-bg-all.3d1f477f.png";